import * as React from 'react';
import moment from 'moment';
import { connect, Dispatch } from 'react-redux';

import ModalHelper from './modal-helper';
import PromoCodeHelper from './promo-code-helper';
import { ICalendarAppState } from '../redux-state';
import { openFiltersDialog, removeAllEventFilters, openMiniCalDialog } from '../redux-state/actions/calendar.actions';
import { IEvent } from '../interfaces';
import Responsive from './responsive';

import CalendarText from '../contexts/calendar-text';
import StickyNav from './navigation/sticky-nav';
import MiniCalendarContainer from './mini-calendar/container';
import ListContainer from './list/container';
import ScrollToTop from './navigation/scroll-to-top';
import Loader from './loader';
import { ICalendarFilterState } from '../redux-state/interfaces/calendar-filter.state';
import { CalendarAppText } from '../redux-state/interfaces/calendar-app-text.state';

import CalendarViewToggle from './calendar-view-toggle'
import CalendarContainer from './calendar-container'
import CalendarEventToggleBase from './calendar-event-toggle ';
import  MonthSelectionDropdownBase  from './month-selection/dropdown';
interface AppExternalProps {

}

interface StateToProps {
    text: CalendarAppText;
    filterState: ICalendarFilterState<IEvent>;
    currentDate: moment.Moment;
    startDate: moment.Moment;
    endDate: moment.Moment;
}

interface DispatchToProps {
    openFiltersDialog: (trigger: HTMLButtonElement) => void;
    openMiniCalDialog: (trigger: HTMLButtonElement) => void;
    clearAllFilters: () => void;
}

export type AppProps = AppExternalProps & StateToProps & DispatchToProps;

/**
 * Wrapper for the entire Calendar app.
 *
 * Provides CalendarText context, and
 */
export class AppComponent extends React.Component<AppProps> {
    constructor(props: AppProps) {
        super(props);
    }

    render() {

        // count the number of active filter conditions
        const activeFilters =
            this.props.filterState.venueFilter.selectedOptions.length +
            this.props.filterState.availabilityFilter.selectedOptions.length +
            this.props.filterState.genreFilter.selectedOptions.length;

        return (
            <CalendarText.Provider value={this.props.text}>

                <section className="ace-cal ace-page-gray">
                  
                    <StickyNav />
                    <CalendarEventToggleBase />
                    <div className="ace-cal-main">
                        <section className="grid-container ace-cal-results">
                            
                            <Loader />
                        </section>
                    </div>
                    <div aria-live="polite">
                        <Responsive />
                        <CalendarContainer />
                    </div>
                    <ScrollToTop />
                </section>
                <ModalHelper />
                <PromoCodeHelper />
            </CalendarText.Provider>
        );
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: AppExternalProps): StateToProps {
    return {
        text: state.calendarText,
        filterState: {
            ...state.calendar
        } as ICalendarFilterState<IEvent>,
        currentDate: state.calendar.currentDate,
        startDate: state.calendar.startDate,
        endDate: state.calendar.endDate
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        openFiltersDialog: (trigger: HTMLButtonElement) => { dispatch(openFiltersDialog(trigger)); },
        clearAllFilters: () => { dispatch(removeAllEventFilters()); },
        openMiniCalDialog: (trigger: HTMLButtonElement) => { dispatch(openMiniCalDialog(trigger)); }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(AppComponent);
